/* eslint-disable no-unused-vars */
import React from "react";
import { motion as m } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useSettings } from "../../context/SettingsContext"; 
import defaultBannerImg from "../../assets/banner/default-banner.png";

const HeroBanner = () => {
  const { bannerUrl, loading: settingsLoading } = useSettings();

  return (
    <div className="relative w-full overflow-hidden bg-white">
      {/* 
          PENGATURAN TINGGI DINAMIS:
          - Mobile: h-[250px]
          - Laptop (md): h-[450px]
          - Desktop (lg): h-[550px]
          - Monitor Besar (2xl): h-[650px] -> Bertambah tinggi saat layar membesar
      */}
      <div className="relative w-full h-[300px] md:h-[500px] lg:h-[550px] 2xl:h-[650px] bg-slate-50">
        <m.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="w-full h-full"
        >
          {settingsLoading ? (
            <div className="w-full h-full flex items-center justify-center">
               <Loader2 className="animate-spin text-blue-600" />
            </div>
          ) : (
            <img 
              src={bannerUrl || defaultBannerImg} 
              alt="Event Banner" 
              /* 
                 - w-full: Tetap mentok kanan-kiri.
                 - object-cover: Mengisi seluruh ruang tinggi yang bertambah tanpa merusak rasio.
              */
              className="w-full h-full object-cover block shadow-md"
            />
          )}
        </m.div>
      </div>
    </div>
  );
};

export default HeroBanner;